<template>
  <div id="app">
    <h1>Salesrun Instances</h1>
    <Info
      v-bind:info="info"
    />
    <Instances
      v-bind:instances="instances"
    />
    <Modal
      v-bind:modalData="modalData"
      v-bind:originalValue="originalValue"
      v-show="isModalVisible"
      @close-modal="closeModal"
      @click-change-modal="changeModal"
    />
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Instances from '@/components/Instances'
import Info from '@/components/Info'

export default {
  name: 'App',
  apiUrl: process.env.API_URL,
  components: {
    Modal, Instances, Info
  },
  data() {
    return {
      isInstanceFree: true,
      isOpen: false,
      isEnable: true,
      modalData: '',
      originalValue: '',
      isModalVisible: false,
      instances: [],
      info: {}
    }
  },
  mounted() {
    fetch('__API_URL__/instances')
      .then(response => response.json())
      .then(json => { this.instances = json })
    fetch('__API_URL__/info')
      .then(response => response.json())
      .then(json => { this.info = json[0] })
  },
  methods: {
    openModal(data) {
      this.modalData = data
      this.originalValue = data.inputText
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    changeModal(data) {
      switch (data.type) {
        case 'instance':
          let isFree = false
          if(data.inputText === '' || data.inputText === 'free' || data.inputText === 'FREE') {
            data.inputText = 'FREE'
            isFree = true
          }
            
          const obj1 = { url: data.instanceUrl, version: data.inputText, isFree: isFree }
          fetch('__API_URL__/instances/create', {
            method: 'POST',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify(obj1)
          })
          
          this.instances[data.instanceIndex].version = data.inputText
          this.instances[data.instanceIndex].isFree = isFree
          break
        case 'service':
          const obj2 = { url: data.serviceUrl, version: data.inputText }
          fetch('__API_URL__/services/create', {
            method: 'POST',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify(obj2)
          })

          this.instances[data.instanceIndex].services[data.serviceIndex].version = data.inputText
          break
        default:
      }
      this.isModalVisible = false
    },
  },
  created() {
    // set componenent name
    this.$root.$refs.App_component = this;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
  display: block;
  position: relative;
  width: 100$

}
#app h1 {
  margin: 5px 10px;
}
a {
    font-size: 12px;
}
p {
    margin: 5px;
    padding: 0px;
}

</style>
